import React, { useEffect, useState } from "react";
import MobilePage, { PageContainer } from "../../../Components/MobilePage";
import { Trans, useTranslation } from "react-i18next";
import PackageList, { PackageListSkeleton } from "./Components/PackageList";
import { useHistory, useLocation } from "react-router-dom";
import makeStyles from "@material-ui/core/styles/makeStyles";
import AppBar from "../../Components/AppBar";
import { renderRemainingDiscountTime } from "../../../Components/TimeCountDownBox";
import { usePictureSets } from "../../../hooks/usePictureSets";
import SubjectSelector, {
  SubjectSelectorSkeleton,
} from "../../Components/SubjectSelector";
import Box from "@material-ui/core/Box";
import useSubjectPackageList from "../../../hooks/useSubjectPackageList";

const useStyles = makeStyles((theme) => ({
  packageOffersHeading: {
    margin: 0,
    fontSize: "15px",
    fontWeight: 500,
    textAlign: "center",
    color: theme.palette.primary.dark,
    display: "none",
    "@media screen and (min-height: 700px)": {
      display: "block",
    },
  },
}));

const PackageListPage = () => {
  const history = useHistory();
  const location = useLocation();
  const classes = useStyles();
  const { currentPictureSet } = usePictureSets();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (location.pathname == "/products/") {
      history.replace("/products/packages/");
    }
  }, [location]);

  const { isLoading, packageInfo } = useSubjectPackageList(
    currentPictureSet,
    i18n.language,
  );

  return (
    <MobilePage fullHeight>
      <PackageListAppBar packageInfo={packageInfo} />
      <PageContainer>
        <h2 className={classes.packageOffersHeading}>
          <Trans>Exclusive deals</Trans>
        </h2>
        {currentPictureSet && (
          <Box justifyContent="center" display="flex">
            <Box sx={{ width: "80vw" }}>
              <SubjectSelector disableGutters />
            </Box>
          </Box>
        )}
        {!currentPictureSet && <SubjectSelectorSkeleton />}
        {packageInfo && !isLoading && (
          <PackageList packageInfo={packageInfo} />
        )}
        {(!packageInfo || isLoading) && <PackageListSkeleton />}
      </PageContainer>
    </MobilePage>
  );
};

const PackageListAppBar = ({ packageInfo }) => {
  const { t } = useTranslation();
  const [remainingTime, setRemainingTime] = useState(0);

  useEffect(() => {
    setRemainingTime(packageInfo?.remainingTime || 0);

    const interval = setInterval(() => {
      setRemainingTime((remainingTime) => remainingTime - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [packageInfo]);

  if (remainingTime <= 0) {
    return <AppBar />;
  }

  console.log("Remaining time", packageInfo.remainingTime, remainingTime);

  const dangerousExtraPromoText = renderRemainingDiscountTime(
    remainingTime,
    t,
  );

  return <AppBar dangerousExtraPromoText={dangerousExtraPromoText} />;
};

export default PackageListPage;
